import {
    PermissionObjInterface,
    ModuleSectionInterface,
    AppMenuInterface,
} from "../types/app-config";

// constants
export const DEVICE_PERMISSION = "device_permission";

export const hasPermission = (
    permissions: PermissionObjInterface,
    permission: string
): boolean => (permissions ? permissions[permission]?.active || false : false);

export const activeSections = (
    sections: ModuleSectionInterface[]
): ModuleSectionInterface[] => {
    try {
        return sections.filter((item) => item.active);
    } catch  {
        return [];
    }
};

export const activeSectionList = (
    sections: ModuleSectionInterface[]
): string[] => {
    try {
        return sections.filter((item) => item.active).map((item) => item.name);
    } catch  {
        return [];
    }
};

export const availableSectionList = (menu: AppMenuInterface): string[] => {
    try {
        return menu.sections.map((item: ModuleSectionInterface) => item.name);
    } catch  {
        return [];
    }
};

export const hasSectionPermission = (
    sections: ModuleSectionInterface[],
    sectionName: string
): boolean => {
    try {
        const section = sections.filter((item) => item.name === sectionName);
        return section[0]?.active || false;
    } catch {
        return false;
    }
};

const capitalizeLabel = (label: string) =>
    label.charAt(0).toUpperCase() + label.slice(1);

export const navigationMenuLabels = (nav_menu: AppMenuInterface[]) => {
    const menuList = []
    nav_menu.map((item) => menuList.unshift(capitalizeLabel(item.label)));
    menuList.push('Other')
    return menuList
}
